import {
    BetSeatIndex,
    BetSeats,
    getEmptyBetSeatsInfo,
} from '@/models/games/blackjack2/SeatPlayerInfo';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store';
import { betSeatsReducer } from './seatReducer';
// slice
export const BJ2_SEAT_KEY = 'app::bj2::seat';
export const bj2SeatsAdapter = createEntityAdapter<BetSeats, number>({
    selectId: br => br.HostId,
    sortComparer: (a, b) => a.HostId - b.HostId,
});
const initialBj2SeatsState = bj2SeatsAdapter.getInitialState();
const bj2SeatsSlice = createSlice({
    name: BJ2_SEAT_KEY,
    initialState: initialBj2SeatsState,
    reducers: {
        init: bj2SeatsAdapter.upsertOne,
        update: bj2SeatsAdapter.updateOne,
        ...betSeatsReducer,
    },
});
export const bj2SeatSliceReducer = bj2SeatsSlice.reducer;
export const bj2SeatSliceActions = bj2SeatsSlice.actions;
// selector
export const getBj2SeatsSelectors = bj2SeatsAdapter.getSelectors<RootState>(
    state => state[BJ2_SEAT_KEY]
);
export const getBetSeats = getBj2SeatsSelectors.selectById;
export const isPlayerSeated = (
    state: RootState,
    hostId: number,
    playerId: number
) => {
    const bj2Seats = getBj2SeatsSelectors.selectById(state, hostId);
    if (bj2Seats) {
        for (let i = 1; i <= 7; i++) {
            const sn = `Seat${i}` as BetSeatIndex;
            if (bj2Seats[sn].PlayerID === playerId) return true;
        }
        return false;
    }
    return false;
};
export const getPlayerSeatNo = (
    state: RootState,
    hostId: number,
    playerId: number
) => {
    const bj2Seats = getBj2SeatsSelectors.selectById(state, hostId);
    if (bj2Seats) {
        for (let i = 1; i <= 7; i++) {
            const sn = `Seat${i}` as BetSeatIndex;
            if (bj2Seats[sn].PlayerID === playerId) return i;
        }
        return undefined;
    }
};

export const getEmptyBJ2Seats = (hostId: number): BetSeats => ({
    HostId: hostId,
    DecisionStateStep: '',
    inSeatLastRound: false,
    Seat1: getEmptyBetSeatsInfo(),
    Seat2: getEmptyBetSeatsInfo(),
    Seat3: getEmptyBetSeatsInfo(),
    Seat4: getEmptyBetSeatsInfo(),
    Seat5: getEmptyBetSeatsInfo(),
    Seat6: getEmptyBetSeatsInfo(),
    Seat7: getEmptyBetSeatsInfo(),
});

//Epic use
export type BJ2BetSummary = {
    isMe: boolean;
    MainBet: number;
    BetBehind: number;
    Pair: number;
    IsBetBehindSplit: boolean;
};
export const getEmptyBJ2BetSummary = (): BJ2BetSummary => {
    return {
        isMe: false,
        MainBet: 0,
        BetBehind: 0,
        Pair: 0,
        IsBetBehindSplit: false,
    };
};
